import {
  RequestResponse,
  RequestStatus,
  RequestType,
  RequestTypeAlias,
  RequestTypeType
} from './requests.types'

export const RequestMapper = {
  toEntity(domain: RequestResponse): RequestType {
    return {
      guid: domain.id,
      id: domain.number,
      title:
        domain.typeAlias === RequestTypeAlias.CommonRequest
          ? domain.serviceName || domain.title
          : domain.title,
      description: domain.description,
      typeAlias: domain.typeAlias,
      premiseId: domain.premiseId,
      status_alias: domain.statusAlias,
      date: domain.createdAt,
      desiredDateStart: domain.desiredDateStart || '',
      desiredDateEnd: domain.desiredDateEnd || '',
      personal_account_guid: domain.personalAccountId,
      stars: domain.rating || 0,
      comments_count: domain.unreadComments,
      persons: domain.persons.length > 0 ? domain.persons : null,
      autos: domain.autos.length > 0 ? domain.autos : null,
      properties: domain.properties?.length ? domain.properties : null,
      isPayable: domain.isPayable
    }
  }
}

export const buildRequestsList = (
  requests?: RequestType[],
  types?: RequestTypeType[],
  statuses?: RequestStatus[]
) =>
  requests?.map(request => {
    const currentType = types?.find(({ alias }) => alias === request.typeAlias)
    const currentStatus = statuses?.find(
      status => status.alias === request.status_alias
    )
    return {
      ...request,
      icon_link: currentType?.iconLink,
      status: currentStatus
    }
  })
